// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GUmG","right":"styles_right__11j_p"};